module.exports = __webpack_public_path__ + "img/thailand-7.44d5aae0.png";